import { Pipe, PipeTransform } from '@angular/core';
import { transformTitle } from 'src/app/helper/class/utilityHelper';

@Pipe({
  name: 'titleCaseExtend'
})
export class TitleCaseExtendPipe implements PipeTransform {
  transform(str: string): string {
    return transformTitle(str || '')
  }
}
